import apiClient from "../lib/apiClient";

//===Get batches=====
// export const fetchBatch = async (classId, subjectId) => {
//   const res = await apiClient.get(
//     `/LiveClasses/GetBatches?classId=${classId}&subjectId=${subjectId}`
//   );
//   return res.data; // 
// };

export const fetchBatch = async (payload) => {
  const res = await apiClient.post(
    `/LiveClasses/GetBatchesByCourses`,payload
  );
  return res.data; // 
};


// Final Subscription API
export const buySubscription = async (payload) => {
  try {
    console.log("API CALL →", payload);

    const res = await apiClient.post(`/LiveClasses/BuySubscription`, payload);

    console.log("API RESPONSE →", res);

    return res.data;

  } catch (err) {
    console.error("API ERROR →", err);

    if (err.response) {
      console.error("BACKEND ERROR →", err.response.data);
    }

    throw err;
  }
};

//=======================verify payment==============
// export const getSubscriptions = async (userId) => {
//   try {
//     const res = await apiClient.get(
//       `/LiveClasses/GetSubscriptions`,
//       {
//         params: { userId }
//       }
//     );

//     console.log("API RAW RESPONSE:", res.data);

//     // IMPORTANT:
//     return res.data;

//   } catch (error) {
//     console.error("GetSubscriptions API Error:", error);

//     return {
//       success: false,
//       data: []
//     };
//   }
// };

export const getSubscriptions = async (userId,schoolId) => {

  try {

    const res = await apiClient.get(
      `/LiveClasses/GetSubscriptions?userId=${userId}&schoolId=${schoolId}`
    );

    return res.data;

  } catch (err) {

    // no subscription
    if (err.response?.status === 404) {

      return {
        success: false,
        data: null
      };
    }

    throw err;
  }
};


//==========Get Packages=============

export const fetchPackages = async (payload) => {
  try {
    const response= await apiClient.post(`/LiveClasses/GetPackages`, payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
      
    );
     return response.data;
  
  }catch(error)
  {
    console.error("Package API Error:", error);
    throw error;
  }
}


//============Get package Plan===============
// export const getPlansByPackageId = async (packageId) => {
//   try {

//     const response = await apiClient.get(
//       `/LiveClasses/GetPlansByPackageId?packageId=${packageId}`
//     );

//     return response.data;

//   } catch (error) {

//     console.error(
//       "Plan API Error:",
//       error
//     );

//     throw error;
//   }
// };

export const getPlans = async (payload) => {
  const res = await apiClient.post(
    "/LiveClasses/GetPlans",
    payload
  );

  return res.data;
};